import { Component, OnInit } from '@angular/core';

import { Event as NavigationEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationStart } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'GSWeb';

  // 2020-08-18: MFCS
  // From: https://hdtuto.com/article/angular-prevent-browser-refresh-button-example
  ngOnInit(){

     window.addEventListener("keyup", disableRefresh);
     window.addEventListener("keydown", disableRefresh);
 
     function disableRefresh( e ) {
       if ((e.which || e.keyCode) == 116) {
		   e.preventDefault(); // Bloqueia (desabilita) a tecla F5. Mas infelizmente, não vale quando o foco é um campo "EDIT" :(
       } else if (((e.which || e.keyCode) == 82) && e.ctrlKey) {
		   e.preventDefault(); // Bloqueia (desabilita) a tecla CTRL+R. Mas infelizmente, não vale quando o foco é um campo "EDIT" :(
	   }
     };

  }
  //

  constructor( router: Router ) {
    router.events
        .pipe(
            // The "events" stream contains all the navigation events. For this demo,
            // though, we only care about the NavigationStart event as it contains
            // information about what initiated the navigation sequence.
            filter(
                ( event: NavigationEvent ) => {

                    return( event instanceof NavigationStart );

                }
            )
        )
        .subscribe(
            ( event: NavigationStart ) => {
					   
                console.group( "NavigationStart Event" );
                // Every navigation sequence is given a unique ID. Even "popstate"
                // navigations are really just "roll forward" navigations that get
                // a new, unique ID.
                console.log( "navigation id:", event.id );
                console.log( "route:", event.url );
                // The "navigationTrigger" will be one of:
                // --
                // - imperative (ie, user clicked a link).
                // - popstate (ie, browser controlled change such as Back button).
                // - hashchange
                // --
                // NOTE: I am not sure what triggers the "hashchange" type.
                console.log( "trigger:", event.navigationTrigger );

                // This "restoredState" property is defined when the navigation
                // event is triggered by a "popstate" event (ex, back / forward
                // buttons). It will contain the ID of the earlier navigation event
                // to which the browser is returning.
                // --
                // CAUTION: This ID may not be part of the current page rendering.
                // This value is pulled out of the browser; and, may exist across
                // page refreshes.
                console.log( "restoredState:", event.restoredState );
				
				var valid1stRouteName = "/(MainForm:login)";				
				
                if ( event.restoredState ) {

                    console.warn(
                        "restoring navigation id:",
                        event.restoredState.navigationId
                    );
                    router.navigate([valid1stRouteName]);
					
                } else if (event.id == 1) {
					
					// início da navegação
					var initUrl = event.url.toLowerCase();
					var validInitUrl = (initUrl == "/") || (initUrl.indexOf( "login" ) !== -1);
					if ( !validInitUrl ) {
						//
						// 2020-08-18: MFCS
						// Iniciar o sistema e não começar do "/" ou do primeiro ROUTER, ocorre nos casos de REFRESH no browser
						//
						console.warn(
							"redirecting due a REFRESH or invalid routing:",
							valid1stRouteName
						);
						// alert( "event.id = " + event.id  + "\r\n" +
						//        "initUrl = " + initUrl + "\r\n" +
						//	      "validInitUrl = " + validInitUrl );
						router.navigate([valid1stRouteName]);
					}
				}

                console.groupEnd();

            }
        )
    ;
	}
}